import React, {Component} from 'react'
import ReactDOM from 'react-dom';

import {connect} from 'react-redux'
import * as contactActions from '../../../actions/chat/contactActions'

import './modalWindowStorage.css'
import FaWechat from 'react-icons/lib/fa/wechat'

import ModalWindowStorageContact from './modalWindowStorageContact/modalWindowStorageContact'

class modalWindowStorage extends Component {

    componentDidMount = () => {
        this.subscribeToEvents()
    }

    componentWillUnmount = () => {
        this.unSubscribeToEvents()
    }

    componentWillReceiveProps(nextProps) {
        if(
            nextProps.contactModals.length !== this.props.contactModals.length ||
                nextProps.contactWindowState !== this.props.contactWindowState
        ) {
            this.windowOnResizeHandler()
        }
    }

    subscribeToEvents = () => {
        window.addEventListener("resize", this.windowOnResizeHandler);
    }

    unSubscribeToEvents = () => {
        window.removeEventListener("resize", this.windowOnResizeHandler);
    }

    windowOnResizeHandler = () => {
        if (typeof this.props.contactModals === 'undefined' || typeof this.props.contactModalsHidden === 'undefined')
            return;

        if (this.props.contactModalsHidden.length > 0) {
            var rect = ReactDOM.findDOMNode(this).getBoundingClientRect()

            if (rect.x > 240) {
                this.props.contactModalUnhide(this.props.contactModalsHidden[0])
            }
        }
    }

    render() {
        return (
            <div className="modalWindowStorage">
                <span><FaWechat /></span>
                <div className="modalWindowStorageContactsContainer">
                    <div className="modalWindowStorageContacts bxchatBgColor2 shadowBox1">
                        {
                            this.props.contacts && this.props.contactModalsHidden.map((contactId) => {
                                const contact = this.props.contacts.find((el) => {
                                    return (el.contactId === contactId)
                                });
                                return (
                                    <ModalWindowStorageContact
                                        key={contactId}
                                        contactName={contact.contactName}
                                        contactModalClose={()=>this.props.contactModalClose(contactId)}
                                        contactSwitchToHidden={()=>this.props.contactSwitchToHidden(contactId)}
                                    />
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        contactWindowState: state.contactReducer.contactWindowState,
        contacts: state.contactReducer.contacts,
        contactModals: state.contactReducer.contactModals,
        contactModalsHidden: state.contactReducer.contactModalsHidden
    }
}

const mapDispatchToProps = {
    contactModalClose: contactActions.contactModalClose,
    contactModalUnhide: contactActions.contactModalUnhide,
    contactSwitchToHidden: contactActions.contactSwitchToHidden
}

export default connect(mapStateToProps, mapDispatchToProps)(modalWindowStorage)


// WEBPACK FOOTER //
// ./src/common/chat/modalWindowStorage/modalWindowStorage.js